import { render, staticRenderFns } from "./WorldNPC.vue?vue&type=template&id=24a3618a&"
import script from "./WorldNPC.vue?vue&type=script&lang=js&"
export * from "./WorldNPC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports